export default __webpack_public_path__ + "static/media/print.947aa835.svg";